module.exports = __webpack_public_path__ + "img/werewolf_howling.93ce015e.jpg";